// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Typography from "@material-ui/core/Typography";
import * as Icons from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { iconStyles } from "../../styles/iconStyles";
import { headerStyles } from "../../styles/generalStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...iconStyles(theme),
  ...headerStyles(theme),
  leftMargin: {
    marginLeft: "10px",
    height: "32px"
  }
});

type AppHeaderClassesType = {
  ...IconStylesClassesType,
  appHeader: DictionaryType,
  headerWrapper: DictionaryType,
  headerTitle: DictionaryType,
  actionItem: DictionaryType,
  leftMargin: DictionaryType
};

type AppHeaderPropsType = {
  classes: AppHeaderClassesType,
  title: string,
  content?: string,
  IconName?: string,
  actions?: Array<React$Node>
};

class AppHeader extends Component<AppHeaderPropsType, *> {
  render(): React$Element<*> {
    const classes = this.props.classes;

    let IconName = Icons["Info"];
    if (this.props.IconName && this.props.IconName in Icons) {
      IconName = Icons[this.props.IconName];
    }

    return (
      <div className={classes.appHeader}>
        <div className={classes.headerWrapper}>
          <Typography variant="h5" className={classes.headerTitle}>
            {this.props.title}
          </Typography>
          {this.props.IconName && (
            <div className={classNames(classes.actionItem, classes.leftMargin)}>
              <IconName
                className={classNames(classes.mediumIcon, classes.greenIcon)}
              />
            </div>
          )}
          {this.props.actions && (
            <div>
              {this.props.actions.map(
                (action: React$Node, i: number): * => {
                  return (
                    <span className={classes.actionItem} key={i}>
                      {action}
                    </span>
                  );
                }
              )}
            </div>
          )}
        </div>
        {this.props.content && (
          <Typography variant="subtitle1">{this.props.content}</Typography>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(AppHeader);
